// assets.js
export const ASSETS = {
	rescure_phoneNumber : "0724-6087993", //救援电话，替换成实际号码
	wifiname:'JMYBY',
	wifipassword : 'jmyby88888888',
	booking_sites : ['自然博物馆','森林之旅'],
	vr_url : "https://07cz257o2io.720yun.com/vr/8e0jt0mOOy0", 
	//vr_url : 'https://farm.evcc.top/Uploads/yuanboyuan/quanjing/index.html',
	parking_appid:"wxa126ebfb6364a660",
	video: {
		promo: 'https://farm.evcc.top/Uploads/yuanboyuan/home_video.mp4', // 宣传视频
		promoImg: 'https://farm.evcc.top/Uploads/yuanboyuan/home_video_cover.jpg' // 封面
	},
	jiaonang: [
		"https://farm.evcc.top/Uploads/yuanboyuan/jiaonang/01.jpg",
		"https://farm.evcc.top/Uploads/yuanboyuan/jiaonang/02.jpg",
		"https://farm.evcc.top/Uploads/yuanboyuan/jiaonang/03.jpg"
	],
	spots: [{
			id: "baiheyi",
			name: "百合驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/baiheyi/00.jpg",
			text: "清代严兆鹤诗云：“学染淡黄萱草色，几枝带露立风斜。”百合花繁叶茂，婀娜多姿，清新淡雅，气味宜人。百合象征着荆门人民“友善和睦”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/baiheyi/01.mp4"],
			images: []
		},
		{
			id: "dujuanyi",
			name: "杜鹃驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/dujuanyi/00.jpg",
			text: "杜鹃是孝感市花，杜鹃驿临近孝感展园。宋代真山民诗云：“归心千古终难白，啼血万山都是红。”杜鹃花是中国三大自然野生名花之一，也是世界四大高山花卉之一。杜鹃花开时，满山的杜鹃鸟也不停地啼叫。那声音听起来凄凉衰怨，于是富有想象力的文人们将满山遍野的红色杜鹃花，描写成“杜鹃啼血”转化的产物，说杜鹃花是杜鹃鸟的血化成的，故名杜鹃花。一说杜鹃又名杜宇，是古蜀帝杜宇的化身。杜鹃象征着荆门人民“执着刚烈”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/dujuanyi/01.mp4"],
			images: []
		},
		{
			id: "guihuayi",
			name: "桂花驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/guihuayi/00.jpg",
			text: "南宋李清照词云：“何须浅碧深红色，自是花中第一流。”桂花是中国十大名花之一。终年常绿，枝繁叶茂，秋季开花，芳香四溢，可谓“独占三秋压群芳”。桂花象征着荆门人民“智慧谦逊”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/guihuayi/01.mp4"],
			images: [
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/guihuayi/01.jpg"
			]
		},
		{
			id: "hehuayi",
			name: "荷花驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/hehuayi/00.jpg",
			text: "北宋理学家周敦颐在《爱莲花》中写道：“出淤泥而不染，濯清涟而不妖。”荷叶如翡翠般碧绿，荷花似锦缎般绚烂，构成了一幅美丽的画卷。荷花，别称莲花，自古被誉为“清廉”的象征。荷花象征荆门人民“高洁清廉”的精神品质。 荆门故事链接：陆九渊是南宋著名的哲学家、教育家，陆王心学的代表人物。陆九渊一生极为清廉，任荆门知军时筑城墙，身先士卒，带头捐献半年俸禄，还亲率妻儿参与筑城。原本预算花费二十万串钱，最后只花了五千串。在荆门任上，他清正廉洁，爱民如子，呕心沥血，事事躬行，大力推行“荆门八政”，使荆门形成了政清弊绝、民风纯厚的局面。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/hehuayi/01.mp4"],
			images: []
		},
		{
			id: "jingchubinshui",
			name: "荆楚滨水",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/jingchubinshui/00.jpg",
			text: "",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/jingchubinshui/01.mp4"],
			images: []
		},
		{
			id: "jingmengleyuan",
			name: "荆梦乐园",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/00.jpg",
			text: "",
			videos: [],
			images: [
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/01.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/02.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/03.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/04.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/05.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/06.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/07.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jingmengleyuan/08.jpg"
			]
		},
		{
			id: "jiupaitongyuan",
			name: "九派通苑",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/jiupaitongyuan/00.jpg",
			text: "九派通苑·城控凯瑞酒店由荆门市城控集团投资兴建，武汉格林凯瑞酒店管理公司运营管理，是荆门城区首家按照国际五星级标准兴建的中式园林合院酒店。酒店毗邻风景秀丽的荆门园博园及市政务中心，传承发扬中国建筑文化之绝妙，亭台楼阁遥相呼应，小桥流水曲径通幽，实现了建筑与自然的完美结合。酒店总营业面积16000平方米。古色古香的竹韵楼、兰馨楼，拥有风格迥异的14个贵宾包厢、2个庭院风格宴会大厅，可容纳680人同时进餐，汇聚本地精品家常菜、粤菜、川菜、湘菜、楚菜等各类五湖四海精英大厨;全景落地、环境幽雅的全日制茶餐厅，品类丰富的自助餐品，最具代表的地方小食，满足您对美食的一切期待;粉墙黛瓦、庭院深邃的菊香楼、梅芳楼、松涛楼，拥有小庭雅苑客房118间，床位数230个，静坐窗前尽是满园春色惹人醉,诗情画意情满怀。",
			videos: [],
			images: [
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jiupaitongyuan/01.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jiupaitongyuan/02.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jiupaitongyuan/03.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/jiupaitongyuan/04.jpg"
			]
		},
		{
			id: "juhuayi",
			name: "菊花驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/juhuayi/00.jpg",
			text: "唐代元稹在诗中写道：“不是花中偏爱菊，此花开后更无花。”菊古称为鞠，《礼记·月令》记载：“季秋之月，鞠有黄华。”菊如聚金，鞠而不落，菊与吉谐音，自古以来都是吉祥长寿的象征，其后又有曾子嘉菊以孝母的典故。菊花是荆门的市花。菊花象征荆门人民“仁孝宽厚”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/juhuayi/01.mp4"],
			images: []
		},
		{
			id: "lanhuayi",
			name: "兰花驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/lanhuayi/00.jpg",
			text: "陶渊明曾写诗：“幽兰生前庭，含薰待清风。” 兰花被誉为“花中君子”、“王者之香”，有着健美俊秀、千差万别的风姿，素雅内向、含蓄不露的品格。兰花象征荆门人民“秀外慧中”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/lanhuayi/01.mp4"],
			images: []
		},
		{
			id: "meiguiyi",

			name: "玫瑰驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/meiguiyi/00.jpg",
			text: "南宋杨万里诗云：“接叶连枝千万绿，一花两色浅深红。”玫瑰形态高贵而优雅，如诗如画。花瓣层层叠叠，轻轻柔柔，宛如女神的裙摆，散发出诱人的魅力。玫瑰象征着荆门人民“浪漫忠贞”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/meiguiyi/01.mp4"],
			images: []
		},
		{
			id: "senlinzhilv",
			name: "森林之旅",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/senlinzhilv/00.jpg",
			text: "",
			videos: [],
			images: [
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/senlinzhilv/01.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/senlinzhilv/02.jpg",
				"https://farm.evcc.top/Uploads/yuanboyuan/spots/senlinzhilv/03.jpg"
			]
		},
		{
			id: "shiliuyi",
			name: "石榴驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/shiliuyi/00.jpg",
			text: "晋代渊岳《安石榴赋》云：“华实并丽，滋味亦殊。商秋受气，收华敛实，千房同蒂，千子如一。缤纷磊落，垂光耀质，滋味浸液，馨香流溢。”习近平总书记强调：“各民族要相互了解、相互尊重、相互包容、相互欣赏、相互学习、相互帮助，像石榴籽那样紧紧抱在一起。”石榴花曾作为荆门市花。石榴象征荆门人民“团结包容”的精神品质。 荆门故事：面对疫情侵扰，荆门全城一盘棋、全民总动员，众志成城筑起一道道安全防线。创建全国文明城市，广大干部群众三年冒酷暑严寒的双向奔向，成就全省“首创首成”的典范。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/shiliuyi/01.mp4"],
			images: []
		},
		{
			id: "shiqiaoyi",
			name: "石桥驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/shiqiaoyi/00.jpg",
			text: "石桥驿位于园博园灵秀荆楚区东北端，总建筑面积5400多平米。建筑南侧集散广场为主要出入口节点，并与园区主路连接。展会期间承担园区一级驿站的功能。做为园博园后续运营的重要组成部分，这里可承接500人规模的研学活动，将创建为省级生态研学基地。建筑是双坡屋面，错落有致的屋顶轮廓线，如山峰连绵，与周边的山形水势融为一体。建筑外装采用了较大面积的竹木外墙表皮，与金属屋面、深色涂料墙面以及钢和玻璃相结合，营造出平和、质朴的意境，响应石桥驿“生态研学”的主题。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/shiqiaoyi/01.mp4"],
			images: []
		},
		{
			id: "shiguangjishi",

			name: "时光集市",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/shiguangjishi/00.jpg",
			text: "利用夜经济特色，独创出市集艺术商亭，增添了网红打卡点、互动装置等。夜市有棉花糖、童年便利店、网红大可乐、百特茶、文创雪糕、淄博烧烤、长沙臭豆腐、炒酸奶、9.9元小串、盼哥豆花、襄阳牛肉面、桥头排骨、趣味圈圈、打气球、关东煮、8090怀旧零食铺、公安锅盔、邓氏阿嬷手作等。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/shiguangjishi/01.mp4"],
			images: []
		},
		{
			id: "taohuayi",
			name: "桃花驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/taohuayi/00.jpg",
			text: "《诗经》云：“桃之夭夭，灼灼其华。”桃花盛开的季节，满树繁花如云似霞，点缀着绿叶，犹如一幅精美的水彩画。桃花象征荆门人民“重情重义”的精神品质。 荆门故事链接：荆门是古代三国重要战场，关羽北伐曹操的军事基地在荆门掇刀。在中国，关羽是武圣，是“忠义”的化身。有关三国及关公的地名及其传说众多，其中以关羽而得名的地名达100余个。关羽义薄云天，特别是桃园三结义的故事千古流传。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/taohuayi/01.mp4"],
			images: []
		},
		{
			id: "yuntaiyi",
			name: "芸薹驿",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/yuntaiyi/00.jpg",
			text: "乾隆皇帝诗云：“黄萼裳裳绿叶稠，千村欣卜榨新油。”芸薹是油菜花的学名，它是大自然的神来之笔。金黄的花海，像是大地的金色织锦，细腻而富有质感。阳光下，油菜花熠熠生辉，散发着生命的光芒。油菜花象征着荆门人民“厚道质朴”的精神品质。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/yuntaiyi/01.mp4"],
			images: []
		},
		{
			id: "ziranbowuguan",
			name: "自然博物馆",
			imgUrl: "https://farm.evcc.top/Uploads/yuanboyuan/spots/ziranbowuguan/00.jpg",
			text: "荆门自然博物馆位于园博园中部核心景观区。作为园博会的主场馆，不仅是标志性建筑，也是反映人与自然和谐共处、展示生态文明建设成就的重要场所。荆门自然博物馆是湖北省第三届（荆门）园博园主场馆，共4层，总建筑面积近1万平米，室内展览及公共区域面积有6000多平米。主展馆以“自然而然 生态家园”为主题，紧扣人与自然和谐共存的关系，以天文、地质地理、自然演化、人类源流与发展等为脉络进行布展。设置序厅、宇宙洪荒、演化奇迹、生命万象、荆门楚望五大展厅，充分利用现代科技声光电等元素，生动鲜活地讲述宇宙奥秘、星球故事，展示地球演化历史、生命万象，以及荆门地方人与自然的故事。这是一座主题内涵丰富、地方特色鲜明，生动传播生态文明的自然类科学博物馆，不仅好看、好玩、而且很有教育意义、有深刻内涵。",
			videos: ["https://farm.evcc.top/Uploads/yuanboyuan/spots/ziranbowuguan/01.mp4"],
			images: []
		}
	]
};